var _rect, _path, _a;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.88391,
    y: 1.06116,
    width: 50,
    height: 50,
    stroke: "#333",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8839 26.0612C23.5558 26.0612 20.8839 23.3893 20.8839 20.0612C20.8839 16.7799 23.5558 14.0612 26.8839 14.0612C30.1652 14.0612 32.8839 16.7799 32.8839 20.0612C32.8839 23.3893 30.1652 26.0612 26.8839 26.0612ZM31.0558 27.5612C34.5245 27.5612 37.3839 30.4205 37.3839 33.8893V35.8112C37.3839 37.0768 36.3527 38.0612 35.1339 38.0612H18.6339C17.3683 38.0612 16.3839 37.0768 16.3839 35.8112V33.8893C16.3839 30.4205 19.1964 27.5612 22.6652 27.5612H23.462C24.4933 28.0768 25.6652 28.3112 26.8839 28.3112C28.1027 28.3112 29.2277 28.0768 30.2589 27.5612H31.0558Z",
    fill: "#333"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://dealsmarineparts.com/my-account/"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    y: -1.8,
    width: 21,
    height: 27.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d8f31c770ea415f53a9aa5b09e51edcd.svg";
export { ForwardRef as ReactComponent };